import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { CentralizedBaggageGuide } from "./BaggageGuide/BaggageGuide";
import { CentralizedLagsAndRestrictedItems } from "./LagsAndRestrictedItems/LagsAndRestrictedItems";

export const CentralizedTravellersInfo = () => {
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    if (query.get("id")) {
      return;
    }

    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdChildActiveTab = query.get("thirdChildActiveTab");
    if (!activeTab) {
      navigate(
        `/centralized/centralizedTravellersInfo?activeTab=centralizedBaggageGuide&subActiveTab=centralizedSingleCabinLuggagePolicy&thirdChildActiveTab=centralizedSingleCabinLuggagePolicyPageContent`,
        {
          replace: true,
        }
      );
    } else {
      let defaultSubActiveTab: string | null = null;
      let defaultThirdChildActiveTab: string | null = null;

      switch (activeTab) {
        case "centralizedBaggageGuide":
          defaultSubActiveTab = "centralizedSingleCabinLuggagePolicy";
          break;
        case "centralizedLagsAndRestrictedItems":
          defaultSubActiveTab = "centralizedLags";
          break;
        default:
          defaultSubActiveTab = "centralizedSingleCabinLuggagePolicy";
          break;
      }

      switch (subActiveTab || defaultSubActiveTab) {
        case "centralizedSingleCabinLuggagePolicy":
          defaultThirdChildActiveTab = "centralizedSingleCabinLuggagePolicyPageContent";
          break;
        case "centralizedGuidelinesForCheckedinLuggage":
          defaultThirdChildActiveTab = "centralizedGuidelinesForCheckedinLuggagePageContent";
          break;
        case "centralizedLags":
          defaultThirdChildActiveTab = "centralizedLagsPageContent";
          break;
        case "centralizedRestrictedItems":
          defaultThirdChildActiveTab = "centralizedRestrictedItemsCheckedInCabinRestrictionsContent";
          break;
      }
      navigate(
        `/centralized/centralizedTravellersInfo?activeTab=${activeTab ?? "centralizedBaggageGuide"}${
          defaultSubActiveTab ? `&subActiveTab=${subActiveTab || defaultSubActiveTab}` : ""
        }${
          defaultThirdChildActiveTab ? `&thirdChildActiveTab=${thirdChildActiveTab || defaultThirdChildActiveTab}` : ""
        }`,
        { replace: true }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab"), query.get("thirdChildActiveTab")]);
  const travellersInfoCard = [
    {
      label: "Baggage Guide",
      key: "centralizedBaggageGuide",
      children: <CentralizedBaggageGuide />,
    },
    {
      label: "Lags & Restricted Items",
      key: "centralizedLagsAndRestrictedItems",
      children: <CentralizedLagsAndRestrictedItems />,
    },
  ];

  const handleProductManagement = (activeTab: any, subActiveTab: any) => {
    if (subActiveTab === "awardsList") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/awards/awardsList/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Award
        </Button>
      );
    } else if (activeTab === "Faqs") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/eramanPrivilegeCard/Faqs/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New FAQ
        </Button>
      );
    } else if (activeTab === "news") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/news/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New News
        </Button>
      );
    } else if (activeTab === "dutyFreeBuyingGuide") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/travellersInfo/dutyFreeBuyingGuide/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Duty Free Buying Guide
        </Button>
      );
    } else if (subActiveTab === "jobOpportunities") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/pages/aboutEraman/careers/jobOpportunities/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add New Job Opportunities
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title={"Traveller's Info"}
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(query.get("activeTab"), query.get("subActiveTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={travellersInfoCard}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
